<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 18 17">
    <path
      d="M14.8235 1.0625V0H11.6471V1.0625H6.35294V0H3.17647V1.0625H0V17H18V1.0625H14.8235ZM12.7059 1.0625H13.7647V3.1875H12.7059V1.0625ZM4.23529 1.0625H5.29412V3.1875H4.23529V1.0625ZM16.9412 15.9375H1.05882V6.46H16.9412V15.9375ZM1.05882 5.3975V2.125H3.17647V4.25H6.35294V2.125H11.6471V4.25H14.8235V2.125H16.9412V5.3975H1.05882Z"
      :class="colorClass"
    />
    <path d="M3.22229 8H5.22229V10H3.22229V8Z" :class="colorClass" />
    <path d="M3.22229 12H5.22229V14H3.22229V12Z" :class="colorClass" />
    <path d="M8.22229 8H10.2223V10H8.22229V8Z" :class="colorClass" />
    <path d="M8.22229 12H10.2223V14H8.22229V12Z" :class="colorClass" />
    <path d="M13.2223 8H15.2223V10H13.2223V8Z" :class="colorClass" />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
